import { handleActions } from 'redux-actions';
import apiCaller from 'client/util/apiCaller';

const FETCH_HUBSPOT_PROPERTIES_START = 'FETCH_HUBSPOT_PROPERTIES_START';
const FETCH_HUBSPOT_PROPERTIES_SUCCESS = 'FETCH_HUBSPOT_PROPERTIES_SUCCESS';
const FETCH_HUBSPOT_PROPERTIES_FAILURE = 'FETCH_HUBSPOT_PROPERTIES_FAILURE';

const initialState = {
  properties: [],
  loading: false,
  lastFetched: null,
  error: null,
};

export const HubspotPropertiesReducer = handleActions(
  {
    [FETCH_HUBSPOT_PROPERTIES_START]: state => ({
      ...state,
      loading: true,
      error: null,
    }),
    [FETCH_HUBSPOT_PROPERTIES_SUCCESS]: (state, action) => ({
      ...state,
      loading: false,
      properties: action.payload,
      lastFetched: Date.now(),
      error: null,
    }),
    [FETCH_HUBSPOT_PROPERTIES_FAILURE]: (state, action) => ({
      ...state,
      loading: false,
      error: action.payload,
    }),
  },
  initialState,
);

export const getHubspotProperties = state => state.hubspotProperties.properties;
export const getHubspotPropertiesLoading = state => state.hubspotProperties.loading;
export const getHubspotPropertiesLastFetched = state => state.hubspotProperties.lastFetched;
export const getHubspotPropertiesError = state => state.hubspotProperties.error;

// Thunk to fetch properties if not cached or cache expired (5min TTL)
export const fetchHubspotPropertiesIfNeeded = () => async (dispatch, getState) => {
  const state = getState();
  const lastFetched = getHubspotPropertiesLastFetched(state);
  const loading = getHubspotPropertiesLoading(state);
  if (loading) {
    // Already fetching, don't start another
    return;
  }
  if (lastFetched && Date.now() - lastFetched < 5 * 60 * 1000) {
    // Cache valid
    return;
  }
  dispatch({ type: FETCH_HUBSPOT_PROPERTIES_START });
  try {
    const res = await apiCaller(dispatch, 'integrations/hubspot/properties');
    dispatch({ type: FETCH_HUBSPOT_PROPERTIES_SUCCESS, payload: Array.isArray(res) ? res : [] });
  } catch (err) {
    dispatch({ type: FETCH_HUBSPOT_PROPERTIES_FAILURE, payload: err.message || 'Failed to fetch' });
  }
};

export default HubspotPropertiesReducer;
